interface CameraWithPlan {
  plan?: {
    amount?: number | null;
  } | null;
}

export const isLiveOnlyPlan = (
  camera: CameraWithPlan | null | undefined,
): boolean => camera?.plan?.amount === 0;
